export const SET_LOYALTY_STORE = "SET_LOYALTY_STORE";
export const SET_LOYALTY_RESET = "SET_LOYALTY_RESET";

// Lấy thông tin tài khoản loyalty
export const FETCH_LOYALTY_ACCOUNT_REQUEST = "FETCH_LOYALTY_ACCOUNT_REQUEST";
export const FETCH_LOYALTY_ACCOUNT_SUCCESS = "FETCH_LOYALTY_ACCOUNT_SUCCESS";
export const FETCH_LOYALTY_ACCOUNT_FAILURE = "FETCH_LOYALTY_ACCOUNT_FAILURE";

// Lấy link webview đổi quà
export const FETCH_LINK_WEBVIEW_LOYALTY_REQUEST = "FETCH_LINK_WEBVIEW_LOYALTY_REQUEST";
export const FETCH_LINK_WEBVIEW_LOYALTY_SUCCESS = "FETCH_LINK_WEBVIEW_LOYALTY_SUCCESS";
export const FETCH_LINK_WEBVIEW_LOYALTY_FAILURE = "FETCH_LINK_WEBVIEW_LOYALTY_FAILURE";
